import React from 'react';
import { PeekStack, PeekTypography } from '@piiqtechnologies/ui-components';
import { usePannellumViewer } from '../../../components/pannellum-viewer/PannellumProvider.js';
import { EditorTooltip } from '../button-menu/EditorTooltip.js';

const NotEditableTooltip = ({ baseMenuRef }) => {
    var _a;
    const { details, spaceId } = usePannellumViewer();
    const linkedSpace = details.unit;
    if (details._id === spaceId || !linkedSpace) {
        return null;
    }
    //@ts-ignore
    const baseMenuContainerPosition = (_a = baseMenuRef === null || baseMenuRef === void 0 ? void 0 : baseMenuRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    return (React.createElement(EditorTooltip, { key: details._id, sx: {
            bottom: baseMenuContainerPosition === null || baseMenuContainerPosition === void 0 ? void 0 : baseMenuContainerPosition.height,
            left: "20px !important",
            top: "unset !important",
            right: "unset !important",
        } },
        React.createElement(PeekStack, { direction: "column", spacing: 1 },
            React.createElement(PeekTypography, { variant: "body1", fontWeight: "fontWeightBold" }, `${linkedSpace} must be edited directly from its page.`))));
};

export { NotEditableTooltip, NotEditableTooltip as default };
